module.exports = __webpack_public_path__ + "officialStatic/img/news12.9d4a443.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/news/news12.jpg
// module id = 6d5u
// module chunks = 0